import { useMutation } from '@tanstack/react-query'
import { QUERIES } from '@/constants/queries'
import type { MatchCoursesFormType } from '@/schemas/education/match-courses-schema'
import { reviewDecisionService } from '@/services/review-decision'

interface useReviewDecisionParams {
  requestId: string
  onDecision?: (decision: 'GRANT' | 'DENY') => void
}

export function useReviewDecision({
  requestId,
  onDecision
}: useReviewDecisionParams) {
  const {
    mutate: grantReviewMutate,
    isPending: grantReviewIsPending,
    isSuccess: grantReviewSuccess
  } = useMutation({
    mutationKey: [QUERIES.QUERY_POST_GRANT_EXTERNAL_TRANSFER],
    mutationFn: (data: MatchCoursesFormType) =>
      reviewDecisionService.grant(requestId, data),
    onSuccess: () => onDecision?.('GRANT')
  })

  const {
    mutate: denyReviewMutate,
    isPending: denyReviewIsPending,
    isSuccess: denyReviewSuccess
  } = useMutation({
    mutationKey: [QUERIES.QUERY_POST_DENY_EXTERNAL_TRANSFER],
    mutationFn: (observation: string) =>
      reviewDecisionService.deny(requestId, observation),
    onSuccess: () => onDecision?.('DENY')
  })

  return {
    states: {
      grantReviewIsPending,
      grantReviewSuccess,
      denyReviewIsPending,
      denyReviewSuccess
    },
    actions: {
      denyReviewMutate,
      grantReviewMutate
    }
  }
}
